import React, { useEffect, useRef } from 'react';
import styles from '../styles/components/_Splashscreen.module.scss';
import { ReactComponent as LogoPoney } from '../assets/images/logoPoney.svg';
import { gsap } from 'gsap';

const Splashscreen = ({ onComplete, duration = 3000 }) => {
  const splashscreenRef = useRef(null);
  const logoRef = useRef(null);
  const titleRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    // Calculer les durées relatives des animations
    const totalDuration = duration / 1000; // Convertir en secondes
    const entranceDuration = totalDuration * 0.2;
    const displayDuration = totalDuration * 0.5;
    const exitDuration = totalDuration * 0.3;

    const ctx = gsap.context(() => {
      animationRef.current = gsap.timeline({
        defaults: { ease: 'power3.out' },
        onComplete: () => {
          if (onComplete) onComplete();
        },
      });

      // Séquence d'animation
      animationRef.current
        // Entrée (20% du temps total)
        .to(splashscreenRef.current, {
          opacity: 1,
          scale: 1,
          duration: entranceDuration * 0.3
        })
        .fromTo(
          logoRef.current,
          { opacity: 0, scale: 0, rotate: 45 },
          {
            opacity: 1,
            scale: 1.2,
            rotate: 0,
            duration: entranceDuration * 0.4
          }
        )
        .to(logoRef.current, {
          scale: 1,
          duration: entranceDuration * 0.3
        })
        .from(titleRef.current, {
          opacity: 0,
          y: 50,
          duration: entranceDuration * 0.4
        }, "-=0.2")
        // Pause pour affichage (50% du temps total)
        .to([logoRef.current, titleRef.current], {
          duration: displayDuration,
        })
        // Sortie (30% du temps total)
        .to([logoRef.current, titleRef.current], {
          y: 0,
          opacity: 0,
          scale: 0.9,
          stagger: exitDuration * 0.1,
          duration: exitDuration * 0.3
        })
        .to(splashscreenRef.current, {
          opacity: 0,
          scale: 1,
          duration: exitDuration * 0.1
        }, "-=0.1")
        .set(splashscreenRef.current, {
          pointerEvents: "none"
        });
    });

    // Nettoyage
    return () => {
      if (animationRef.current) {
        animationRef.current.kill();
      }
      ctx.revert();
    };
  }, []); // Uniquement au montage

  return (
    <div
      className={styles.splashscreen}
      ref={splashscreenRef}
      style={{ opacity: 0 }}
    >
      <LogoPoney className={styles.logoSvg} ref={logoRef} />
      <h2 className={styles.title} ref={titleRef}>
        Poney Club
      </h2>
    </div>
  );
};

export default Splashscreen;